import { Button } from "@/components/ui/Button";
import type { ZplPrintDocument } from "@/lib/zplPrintLocation";
import { ZplLocationSelect } from "@/components/ZplLocationSelect";
import type { ClampQcInventoryBoxSnapshot } from "./clampQcInventoryBoxApi";
import { resolveClampQcInventoryBoxPrinterActions } from "./clampQcCartonProgressDisplay";

export function ClampQcHeaderPrinterSelect({
  station,
  onStationChange,
  unavailableMessage,
  documents,
}: {
  station: string;
  onStationChange: (station: string) => void;
  unavailableMessage?: string | null;
  documents: readonly ZplPrintDocument[];
}): JSX.Element {
  return (
    <div className="flex w-full min-w-[14rem] shrink-0 flex-col items-stretch gap-1 sm:max-w-xs sm:items-end">
      <ZplLocationSelect
        id="clamp-qc-inventory-zpl-location-header"
        size="touch"
        value={station}
        onChange={onStationChange}
        unavailableMessage={unavailableMessage}
        className="w-full"
      
      documents={documents}
    />
    </div>
  );
}

export function ClampQcInventoryBoxActions({
  boxCapacity,
  selectedPrinter,
  inventoryBox,
  inventoryBoxSessionStarted,
  inventoryBoxBusy,
  onOpenAndPrintBox,
  onReprintBoxLabel,
  onSealBox,
  onStartNextBox,
}: {
  boxCapacity: number;
  selectedPrinter: string;
  inventoryBox: ClampQcInventoryBoxSnapshot | null;
  inventoryBoxSessionStarted: boolean;
  inventoryBoxBusy: boolean;
  onOpenAndPrintBox: () => void;
  onReprintBoxLabel: () => void;
  onSealBox: () => void;
  onStartNextBox: () => void;
}): JSX.Element | null {
  if (boxCapacity <= 0) {
    return null;
  }
  const printDisabled = selectedPrinter.trim() === "" || inventoryBoxBusy;
  const openBox = inventoryBox != null && !inventoryBox.sealed;
  const postQcFilled = inventoryBox?.filledCount ?? 0;
  const actions = resolveClampQcInventoryBoxPrinterActions({
    inventoryBox,
    inventoryBoxSessionStarted,
  });

  return (
    <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">
      {actions.showPrintFirstBox ? (
        <Button type="button" disabled={printDisabled} onClick={onOpenAndPrintBox}>
          {`Print box label (${String(boxCapacity)})`}
        </Button>
      ) : null}
      {actions.showReprint ? (
        <Button type="button" variant="secondary" disabled={printDisabled} onClick={onReprintBoxLabel}>
          Reprint box label
        </Button>
      ) : null}
      {actions.showSeal && openBox ? (
        <Button type="button" disabled={inventoryBoxBusy || postQcFilled < 1} onClick={onSealBox}>
          Seal box
        </Button>
      ) : null}
      {actions.showNextBox ? (
        <Button type="button" disabled={printDisabled} onClick={onStartNextBox}>
          {`Next box (${String(boxCapacity)})`}
        </Button>
      ) : null}
    </div>
  );
}
